import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fb35801"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "app__header__title" }
const _hoisted_3 = { class: "truncate-name" }
const _hoisted_4 = { class: "container-speaker text-center" }
const _hoisted_5 = { class: "title-text truncate-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_ctx.speakerData.length != 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("speakers.main")), 1),
        _createVNode(_component_el_carousel, {
          class: "mt-1",
          interval: 3000,
          height: "400px",
          type: _ctx.type === 'sm' ? '' : 'card'
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speakerData, (speaker, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { class: "speaker-card" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "speaker-name-tag",
                        style: _normalizeStyle({ backgroundColor: _ctx.colors[index] })
                      }, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.cutString(speaker.speakerName, 10)), 1)
                      ], 4),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_avatar, {
                          class: "speaker-avatar speaker__pp",
                          fit: "contain",
                          style: _normalizeStyle({ border: `2px solid ${_ctx.colors[index]}` }),
                          size: 100,
                          src: 
                speaker.picture
                  ? speaker.picture
                  : require('@/assets/no_profile_image.png')
              
                        }, null, 8, ["style", "src"]),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(speaker.title), 1),
                        _createElementVNode("p", null, _toDisplayString(speaker.description), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["type"])
      ]))
    : _createCommentVNode("", true)
}